import { render } from "./AddSliderHero.vue?vue&type=template&id=a8ba860e&scoped=true"
import script from "./AddSliderHero.vue?vue&type=script&lang=js"
export * from "./AddSliderHero.vue?vue&type=script&lang=js"

import "./AddSliderHero.vue?vue&type=style&index=0&id=a8ba860e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ba860e"]])

export default __exports__